import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { Table, Tag } from 'antd';
import NavbarAdminMex from '../components/navbar';
import './seguro99.css';

const Seguro99 = () => {
  const [seguroData, setSeguroData] = useState(null);
  const [sucursalesData, setSucursalesData] = useState(null);
  const [alertasData, setAlertasData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showAlertasModal, setShowAlertasModal] = useState(false);
  const [loadingSucursales, setLoadingSucursales] = useState(false);
  const [loadingAlertas, setLoadingAlertas] = useState(false);
  const [selectedPeriodo, setSelectedPeriodo] = useState('global');
  const [isLoadingButtonExcel, setIsLoadingButtonExcel] = useState(false);
  
  // Estado para mostrar todas las alertas (rojas, amarillas, verdes, etc.)
  const [allAlertas, setAllAlertas] = useState([]);

  // Estados para ordenamiento de tablas - funcionalidad mejorada
  const [sucursalesSortConfig, setSucursalesSortConfig] = useState({ key: null, direction: 'asc' });
  const [alertasSortConfig, setAlertasSortConfig] = useState({ key: null, direction: 'asc' });

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('https://api.99envios.app/api/online/info/admin/seguro99', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setSeguroData(response.data);
    } catch (error) {
      console.error('Error al obtener los datos de la API', error);
    }
  };

  const fetchSucursalesData = async (periodo = 'global') => {
    try {
      setLoadingSucursales(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `https://integration.99envios.app/api/sucursales/seguro-resumen?periodo=${periodo}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      setSucursalesData(response.data);
    } catch (error) {
      console.error('Error al obtener los datos de sucursales', error);
    } finally {
      setLoadingSucursales(false);
    }
  };

  const fetchAlertasData = async () => {
    try {
      setLoadingAlertas(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(
        'https://integration.99envios.app/api/sucursales/alertas-seguro',
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      setAlertasData(response.data);
      
      // Combinar TODAS las alertas de todos los tipos en un solo array
      let todasLasAlertas = [];
      if (response.data?.alertas) {
        // Agregar alertas rojas (críticas)
        if (response.data.alertas.roja) {
          todasLasAlertas = [...todasLasAlertas, ...response.data.alertas.roja.map(alerta => ({
            ...alerta,
            tipo_alerta: 'crítica',
            color_nivel: '#f44336'
          }))];
        }
        
        // Agregar alertas amarillas (moderadas)
        if (response.data.alertas.amarilla) {
          todasLasAlertas = [...todasLasAlertas, ...response.data.alertas.amarilla.map(alerta => ({
            ...alerta,
            tipo_alerta: 'moderada',
            color_nivel: '#ff9800'
          }))];
        }
        
        // Agregar alertas verdes (leves)
        if (response.data.alertas.verde) {
          todasLasAlertas = [...todasLasAlertas, ...response.data.alertas.verde.map(alerta => ({
            ...alerta,
            tipo_alerta: 'leve',
            color_nivel: '#4caf50'
          }))];
        }
        
        // Agregar cualquier otro tipo de alerta que pueda existir
        Object.keys(response.data.alertas).forEach(tipoAlerta => {
          if (!['roja', 'amarilla', 'verde'].includes(tipoAlerta) && Array.isArray(response.data.alertas[tipoAlerta])) {
            todasLasAlertas = [...todasLasAlertas, ...response.data.alertas[tipoAlerta].map(alerta => ({
              ...alerta,
              tipo_alerta: tipoAlerta,
              color_nivel: '#666'
            }))];
          }
        });
      }
      
      setAllAlertas(todasLasAlertas);
      console.log('Total de alertas cargadas:', todasLasAlertas.length);
      console.log('Tipos de alertas encontradas:', response.data?.alertas ? Object.keys(response.data.alertas) : []);
    } catch (error) {
      console.error('Error al obtener los datos de alertas', error);
      setAllAlertas([]);
    } finally {
      setLoadingAlertas(false);
    }
  };

  const loadMoreAlertas = () => {
    // Esta función ya no es necesaria, pero la mantenemos para evitar errores
    return;
  };

  const handleOpenModal = () => {
    setShowModal(true);
    // Resetear ordenamiento al abrir modal
    setSucursalesSortConfig({ key: null, direction: 'asc' });
    fetchSucursalesData(selectedPeriodo);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    // Resetear ordenamiento al cerrar modal
    setSucursalesSortConfig({ key: null, direction: 'asc' });
  };

  const handleOpenAlertasModal = () => {
    setShowAlertasModal(true);
    // Resetear ordenamiento al abrir modal de alertas
    setAlertasSortConfig({ key: null, direction: 'asc' });
    // Siempre cargar datos frescos del API
    fetchAlertasData();
  };

  const handleCloseAlertasModal = () => {
    setShowAlertasModal(false);
    // Resetear ordenamiento al cerrar modal
    setAlertasSortConfig({ key: null, direction: 'asc' });
  };

  const handlePeriodoChange = (nuevoPeriodo) => {
    setSelectedPeriodo(nuevoPeriodo);
    // Resetear ordenamiento al cambiar período
    setSucursalesSortConfig({ key: null, direction: 'asc' });
    fetchSucursalesData(nuevoPeriodo);
  };

  const downloadSucursalesExcel = () => {
    setIsLoadingButtonExcel(true);
    if (!sucursalesData || !sucursalesData.sucursales) {
      alert('No hay datos de sucursales para descargar');
      return;
    }

    // Preparar los datos para el Excel
    const excelData = sucursalesData.sucursales.map(sucursal => ({
      'Código': sucursal.codigo_sucursal,
      'Nombre Sucursal': sucursal.nombre_sucursal,
      'Total Envíos': sucursal.total_envios_seguro,
      'Entregas': sucursal.entregas,
      'Devoluciones': sucursal.devoluciones,
      '% Entregas': `${sucursal.porcentaje_entregas.toFixed(2)}%`,
      '% Devoluciones': `${sucursal.porcentaje_devoluciones.toFixed(2)}%`,
      '% Seguro Actual': `${(sucursal.porcentaje_seguro_actual * 100).toFixed(2)}%`,
      'Muestra Mínima': sucursal.muestra_minima ? 'Sí' : 'No'
    }));

    // Crear el workbook y worksheet
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sucursales Seguro99');

    // Ajustar el ancho de las columnas
    const columnWidths = [
      { wch: 12 }, // Código
      { wch: 30 }, // Nombre Sucursal
      { wch: 15 }, // Total Envíos
      { wch: 12 }, // Entregas
      { wch: 15 }, // Devoluciones
      { wch: 15 }, // % Entregas
      { wch: 18 }, // % Devoluciones
      { wch: 18 }, // % Seguro Actual
      { wch: 15 }  // Muestra Mínima
    ];
    ws['!cols'] = columnWidths;

    // Generar el nombre del archivo con fecha
    const fecha = new Date().toISOString().split('T')[0];
    const periodoLabel = getPeriodoLabel(selectedPeriodo).replace(/\s+/g, '_');
    const fileName = `Sucursales_Seguro99_${periodoLabel}_${fecha}.xlsx`;

    // Descargar el archivo
    XLSX.writeFile(wb, fileName);
    setIsLoadingButtonExcel(false);
  };

  const downloadAlertasExcel = () => {
    if (!allAlertas || allAlertas.length === 0) {
      alert('No hay datos de alertas para descargar');
      return;
    }

    const excelData = allAlertas.map(alerta => ({
      'Código': alerta.codigo_sucursal, 
      'Nombre Sucursal': alerta.nombre_sucursal,
      'Tipo de Alerta': alerta.tipo_alerta,
      'Total Envíos': alerta.total_envios_seguro,
      'Entregas': alerta.entregas,
      'Devoluciones': alerta.devoluciones,
      '% Entregas': alerta.porcentaje_entregas.toFixed(2),
      '% Devoluciones': alerta.porcentaje_devoluciones.toFixed(2),
      'Nivel de Alerta': alerta.nivel_alerta,
      'Descripción': alerta.descripcion,
      'Recomendación': alerta.recomendacion
    }));

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Alertas Seguro99');

    const columnWidths = [
      { wch: 12 }, // Código
      { wch: 30 }, // Nombre Sucursal
      { wch: 15 }, // Tipo de Alerta
      { wch: 12 }, // Total envios seguro
      { wch: 15 }, // Entregas
      { wch: 15 }, // Devoluciones
      { wch: 15 }, // % Entregas
      { wch: 18 }, // % Devoluciones
      { wch: 15 }, // Nivel de Alerta
      { wch: 30 }, // Descripción
      { wch: 30 }  // Recomendación
    ];
    ws['!cols'] = columnWidths;

    const fecha = new Date().toISOString().split('T')[0];
    const periodoLabel = getPeriodoLabel(selectedPeriodo).replace(/\s+/g, '_');
    const fileName = `Alertas_Seguro99_${periodoLabel}_${fecha}.xlsx`;

    XLSX.writeFile(wb, fileName);
  }

  useEffect(() => {
    fetchData();
    // Cargar todos los datos de alertas al montar el componente
    fetchAlertasData();
  }, []);

  // Hook para manejar el scroll - ya no es necesario
  const handleScroll = useCallback(() => {
    // Función vacía para mantener compatibilidad
    return;
  }, []);

  const formatCurrency = (value) => {
    if (typeof value === 'string') {
      value = parseFloat(value);
    }
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0
    }).format(value);
  };

  const formatNumber = (value) => {
    return new Intl.NumberFormat('es-CO').format(value);
  };

  const getEstadoName = (estadoId) => {
    const estados = {
      '1': 'Pendientes',
      '2': 'En Tránsito',
      '3': 'Entregados',
      '5': 'Devueltos',
      '8': 'En Verificación',
      '9': 'En Revisión',
      '11': 'Tránsito Final'
    };
    return estados[estadoId] || `Estado ${estadoId}`;
  };

  const getPeriodoLabel = (periodo) => {
    switch(periodo) {
      case 'global':
        return 'Global';
      case '15':
        return 'Últimos 15 días';
      case '30':
        return 'Últimos 30 días';
      default:
        return periodo;
    }
  };

  // Configuración de columnas para tabla de sucursales
  const sucursalesColumns = [
    {
      title: 'Código',
      dataIndex: 'codigo_sucursal',
      key: 'codigo_sucursal',
      sorter: (a, b) => parseInt(a.codigo_sucursal) - parseInt(b.codigo_sucursal),
      sortDirections: ['ascend', 'descend'],
      render: (text) => (
        <span style={{ fontWeight: 'bold', color: '#1976D2' }}>
          {text}
        </span>
      ),
    },
    {
      title: 'Nombre Sucursal',
      dataIndex: 'nombre_sucursal',
      key: 'nombre_sucursal',
      sorter: (a, b) => a.nombre_sucursal.localeCompare(b.nombre_sucursal),
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: 'Total Envíos',
      dataIndex: 'total_envios_seguro',
      key: 'total_envios_seguro',
      sorter: (a, b) => a.total_envios_seguro - b.total_envios_seguro,
      sortDirections: ['ascend', 'descend'],
      align: 'center',
      render: (text) => (
        <span style={{ fontWeight: '600' }}>
          {formatNumber(text)}
        </span>
      ),
    },
    {
      title: 'Entregas',
      dataIndex: 'entregas',
      key: 'entregas',
      sorter: (a, b) => a.entregas - b.entregas,
      sortDirections: ['ascend', 'descend'],
      align: 'center',
      render: (text) => (
        <span style={{ color: '#4CAF50', fontWeight: '600' }}>
          {formatNumber(text)}
        </span>
      ),
    },
    {
      title: 'Devoluciones',
      dataIndex: 'devoluciones',
      key: 'devoluciones',
      sorter: (a, b) => a.devoluciones - b.devoluciones,
      sortDirections: ['ascend', 'descend'],
      align: 'center',
      render: (text) => (
        <span style={{ color: '#f44336', fontWeight: '600' }}>
          {formatNumber(text)}
        </span>
      ),
    },
    {
      title: '% Entregas',
      dataIndex: 'porcentaje_entregas',
      key: 'porcentaje_entregas',
      sorter: (a, b) => a.porcentaje_entregas - b.porcentaje_entregas,
      sortDirections: ['ascend', 'descend'],
      align: 'center',
      render: (text) => (
        <span style={{ 
          color: text >= 80 ? '#4CAF50' : text >= 60 ? '#FF9800' : '#f44336',
          fontWeight: '600'
        }}>
          {text.toFixed(2)}%
        </span>
      ),
    },
    {
      title: '% Devoluciones',
      dataIndex: 'porcentaje_devoluciones',
      key: 'porcentaje_devoluciones',
      sorter: (a, b) => a.porcentaje_devoluciones - b.porcentaje_devoluciones,
      sortDirections: ['ascend', 'descend'],
      align: 'center',
      render: (text) => (
        <span style={{ 
          color: text <= 20 ? '#4CAF50' : text <= 40 ? '#FF9800' : '#f44336',
          fontWeight: '600'
        }}>
          {text.toFixed(2)}%
        </span>
      ),
    },
    {
      title: '% Seguro Actual',
      dataIndex: 'porcentaje_seguro_actual',
      key: 'porcentaje_seguro_actual',
      sorter: (a, b) => a.porcentaje_seguro_actual - b.porcentaje_seguro_actual,
      sortDirections: ['ascend', 'descend'],
      align: 'center',
      render: (text) => (
        <span style={{ fontWeight: '600' }}>
          {(text * 100).toFixed(2)}%
        </span>
      ),
    },
    {
      title: 'Muestra Mínima',
      dataIndex: 'muestra_minima',
      key: 'muestra_minima',
      sorter: (a, b) => (a.muestra_minima ? 1 : 0) - (b.muestra_minima ? 1 : 0),
      sortDirections: ['ascend', 'descend'],
      align: 'center',
      render: (muestra_minima) => (
        <Tag color={muestra_minima ? 'green' : 'red'}>
          {muestra_minima ? 'Sí' : 'No'}
        </Tag>
      ),
    },
  ];

  // Configuración de columnas para tabla de alertas
  const alertasColumns = [
    {
      title: 'Código',
      dataIndex: 'codigo_sucursal',
      key: 'codigo_sucursal',
      sorter: (a, b) => parseInt(a.codigo_sucursal) - parseInt(b.codigo_sucursal),
      sortDirections: ['ascend', 'descend'],
      render: (text, record) => (
        <span style={{ fontWeight: 'bold', color: record.color_nivel }}>
          {text}
        </span>
      ),
    },
    {
      title: 'Nombre Sucursal',
      dataIndex: 'nombre_sucursal',
      key: 'nombre_sucursal',
      sorter: (a, b) => a.nombre_sucursal.localeCompare(b.nombre_sucursal),
      sortDirections: ['ascend', 'descend'],
      render: (text) => (
        <span style={{ fontWeight: '600' }}>
          {text}
        </span>
      ),
    },
    {
      title: 'Tipo de Alerta',
      dataIndex: 'tipo_alerta',
      key: 'tipo_alerta',
      sorter: (a, b) => a.tipo_alerta.localeCompare(b.tipo_alerta),
      sortDirections: ['ascend', 'descend'],
      align: 'center',
      render: (text, record) => (
        <Tag 
          color={record.color_nivel === '#f44336' ? 'red' : record.color_nivel === '#ff9800' ? 'orange' : 'green'}
          style={{ textTransform: 'capitalize' }}
        >
          {text}
        </Tag>
      ),
    },
    {
      title: 'Total Envíos',
      dataIndex: 'total_envios_seguro',
      key: 'total_envios_seguro',
      sorter: (a, b) => a.total_envios_seguro - b.total_envios_seguro,
      sortDirections: ['ascend', 'descend'],
      align: 'center',
      render: (text) => (
        <span style={{ fontWeight: '600' }}>
          {formatNumber(text)}
        </span>
      ),
    },
    {
      title: 'Entregas',
      dataIndex: 'entregas',
      key: 'entregas',
      sorter: (a, b) => a.entregas - b.entregas,
      sortDirections: ['ascend', 'descend'],
      align: 'center',
      render: (text) => (
        <span style={{ color: '#4CAF50', fontWeight: '600' }}>
          {formatNumber(text)}
        </span>
      ),
    },
    {
      title: 'Devoluciones',
      dataIndex: 'devoluciones',
      key: 'devoluciones',
      sorter: (a, b) => a.devoluciones - b.devoluciones,
      sortDirections: ['ascend', 'descend'],
      align: 'center',
      render: (text, record) => (
        <span style={{ color: record.color_nivel, fontWeight: '600' }}>
          {formatNumber(text)}
        </span>
      ),
    },
    {
      title: '% Entregas',
      dataIndex: 'porcentaje_entregas',
      key: 'porcentaje_entregas',
      sorter: (a, b) => a.porcentaje_entregas - b.porcentaje_entregas,
      sortDirections: ['ascend', 'descend'],
      align: 'center',
      render: (text) => (
        <span style={{ 
          color: text === 0 ? '#f44336' : '#4CAF50',
          fontWeight: '600'
        }}>
          {text.toFixed(2)}%
        </span>
      ),
    },
    {
      title: '% Devoluciones',
      dataIndex: 'porcentaje_devoluciones',
      key: 'porcentaje_devoluciones',
      sorter: (a, b) => a.porcentaje_devoluciones - b.porcentaje_devoluciones,
      sortDirections: ['ascend', 'descend'],
      align: 'center',
      render: (text, record) => (
        <span style={{ 
          color: record.color_nivel,
          fontWeight: '600'
        }}>
          {text.toFixed(2)}%
        </span>
      ),
    },
    {
      title: 'Nivel de Alerta',
      dataIndex: 'nivel_alerta',
      key: 'nivel_alerta',
      sorter: (a, b) => a.nivel_alerta.localeCompare(b.nivel_alerta),
      sortDirections: ['ascend', 'descend'],
      align: 'center',
      render: (text, record) => (
        <Tag 
          color={record.color_nivel === '#f44336' ? 'red' : record.color_nivel === '#ff9800' ? 'orange' : 'green'}
          style={{ 
            fontWeight: '700',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}
        >
          {text}
        </Tag>
      ),
    },
    {
      title: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      align: 'center',
      render: (text) => (
        <span className="descripcion-cell">
          {text}
        </span>
      ),
    },
    {
      title: 'Recomendación',
      dataIndex: 'recomendacion',
      key: 'recomendacion',
      align: 'center',
      render: (text) => (
        <span className="recomendacion-cell">
          {text}
        </span>
      ),
    },
  ];

  return (
    <>
      <NavbarAdminMex title={"Seguro 99"} />
      <div className="dashboard-containerAD">
        {seguroData ? (
          <div className="cards-containerAD">
            {/* Botones de acceso rápido */}
            <div className="rowAD">
              <div className="cardAD buttons-card">
                <div className="buttons-container">
                  <button 
                    onClick={handleOpenModal} 
                    className="btn-primary"
                  >
                    📊 Ver Resumen de Sucursales
                  </button>
                  <button 
                    onClick={handleOpenAlertasModal} 
                    className="btn-secondary"
                  >
                    🚨 Ver Alertas de Seguro
                  </button>
                </div>
              </div>
            </div>
            
            <div className="rowAD">
              <div className="cardAD">
                <div className="icon-circle-AD local-shipping-icon">
                  <span className="material-icons-sharp" style={{ fontSize: '28px' }}> security </span>
                </div>
                <h3>Total Envíos</h3>
                <p className="main-number">
                  {formatNumber(seguroData.estado_general.total_envios.con_seguro + seguroData.estado_general.total_envios.sin_seguro)}
                </p>
              </div>
              <div className="cardAD">
                <div className="icon-circle-AD check-circle-icon">
                  <span className="material-icons-sharp" style={{ fontSize: '28px', marginTop: 1 }}> verified_user </span>
                </div>
                <h3>Con Seguro</h3>
                <p className="main-number">{formatNumber(seguroData.estado_general.total_envios.con_seguro)}</p>
                <p className="sub-text">{seguroData.estado_general.total_envios.porcentaje_con_seguro.toFixed(2)}%</p>
              </div>
              <div className="cardAD">
                <div className="icon-circle-AD report-icon">
                  <span className="material-icons-sharp" style={{ fontSize: '28px', marginTop: 3 }}> block </span>
                </div>
                <h3>Sin Seguro</h3>
                <p className="main-number">{formatNumber(seguroData.estado_general.total_envios.sin_seguro)}</p>
                <p className="sub-text">{(100 - seguroData.estado_general.total_envios.porcentaje_con_seguro).toFixed(2)}%</p>
              </div>
            </div>
            <div className="rowAD">
              <div className="cardAD">
                <div className="icon-circle-AD track-changes-icon">
                  <span className="material-icons-sharp" style={{ fontSize: '28px', marginTop: 3 }}> money </span>
                </div>
                <h3>Valor Recaudado</h3>
                <p className="main-number">{formatCurrency(seguroData.estado_general.cobertura_financiera.valor_recaudado_seguro.valor)}</p>
                <p className="sub-text">Solo entregados</p>
              </div>
              <div className="cardAD">
                <div className="icon-circle-AD public-icon">
                  <span className="material-icons-sharp" style={{ fontSize: '28px' }}> trending_up </span>
                </div>
                <h3>Valor Potencial</h3>
                <p className="main-number">{formatCurrency(seguroData.estado_general.metricas.valor_potencial_seguro.valor)}</p>
                <p className="sub-text">Total posible</p>
              </div>
              <div className="cardAD">
                <div className="icon-circle-AD check-circle-icon">
                  <span className="material-icons-sharp" style={{ fontSize: '28px', marginTop: 3 }}> shield_check </span>
                </div>
                <h3>Cobertura Financiera</h3>
                <p className="main-number">{Number(seguroData.estado_general.cobertura_financiera.porcentaje_cobertura.valor).toFixed(2)}%</p>
                <p className="sub-text">{seguroData.estado_general.cobertura_financiera.porcentaje_cobertura.estado}</p>
              </div>
            </div>
            <div className="rowAD">
              <div className="cardAD">
                <div className="icon-circle-AD local-shipping-icon">
                  <span className="material-icons-sharp" style={{ fontSize: '28px', marginTop: 3 }}> inventory </span>
                </div>
                <h3>Envíos con Seguro por Estado</h3>
                <table className="card-table-DM">
                  <tbody>
                    {Object.entries(seguroData.con_seguro).map(([estado, data]) => (
                      <tr key={estado}>
                        <td>{getEstadoName(estado)}</td>
                        <td className="number-cell-DM">{formatNumber(data.cantidad_registros)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="cardAD">
                <div className="icon-circle-AD check-circle-icon">
                  <span className="material-icons-sharp" style={{ fontSize: '28px', marginTop: 3 }}> assessment </span>
                </div>
                <h3>Resumen por Categoría</h3>
                <table className="card-table-DM">
                  <tbody>
                    <tr>
                      <td>Entregados</td>
                      <td className="number-cell-DM">{formatNumber(seguroData.estado_general.envios_con_seguro.entregados.cantidad)}</td>
                    </tr>
                    <tr>
                      <td>Devueltos</td>
                      <td className="number-cell-DM">{formatNumber(seguroData.estado_general.envios_con_seguro.devueltos.cantidad)}</td>
                    </tr>
                    <tr>
                      <td>Pendientes</td>
                      <td className="number-cell-DM">{formatNumber(seguroData.estado_general.envios_con_seguro.pendientes.cantidad)}</td>
                    </tr>
                    <tr>
                      <td>En Proceso</td>
                      <td className="number-cell-DM">{formatNumber(seguroData.estado_general.procesos_iniciados.total.cantidad)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="cardAD">
                <div className="icon-circle-AD report-icon">
                  <span className="material-icons-sharp" style={{ fontSize: '28px', marginTop: 3 }}> pie_chart </span>
                </div>
                <h3>Métricas de Rendimiento</h3>
                <table className="card-table-DM">
                  <tbody>
                    <tr>
                      <td>Efectividad</td>
                      <td className="number-cell-DM">{Number(seguroData.estado_general.metricas.porcentaje_efectividad.valor).toFixed(2)}%</td>
                    </tr>
                    <tr>
                      <td>En Proceso</td>
                      <td className="number-cell-DM">{Number(seguroData.estado_general.metricas.porcentaje_en_proceso.valor).toFixed(2)}%</td>
                    </tr>
                    <tr>
                      <td>Realización</td>
                      <td className="number-cell-DM">{Number(seguroData.estado_general.metricas.porcentaje_realizacion.valor).toFixed(2)}%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {seguroData.sin_seguro && Object.keys(seguroData.sin_seguro).length > 0 && (
              <div className="rowAD">              <div className="cardAD">
                <div className="icon-circle-AD report-icon">
                  <span className="material-icons-sharp" style={{ fontSize: '28px', marginTop: 3 }}> warning </span>
                </div>
                <h3>Envíos sin Seguro por Estado</h3>
                <table className="card-table-DM">
                  <tbody>
                    {Object.entries(seguroData.sin_seguro).map(([estado, data]) => (
                      <>
                        <tr key={`${estado}-count`}>
                          <td>{getEstadoName(estado)} - Cantidad</td>
                          <td className="number-cell-DM">{formatNumber(data.cantidad_registros)}</td>
                        </tr>
                        {parseFloat(data.total_valor_servicio) > 0 && (
                          <tr key={`${estado}-servicio`}>
                            <td>{getEstadoName(estado)} - Servicio</td>
                            <td className="number-cell-DM">{formatCurrency(data.total_valor_servicio)}</td>
                          </tr>
                        )}
                      </>
                    ))}
                    </tbody>
                  </table>
                </div>
                <div className="cardAD">
                  <div className="icon-circle-AD public-icon">
                    <span className="material-icons-sharp" style={{ fontSize: '28px', marginTop: 3 }}> receipt_long </span>
                  </div>
                  <h3>Valores de Seguro por Estado</h3>
                  <table className="card-table-DM">
                    <tbody>
                      {Object.entries(seguroData.con_seguro).map(([estado, data]) => (
                        <>
                          <tr key={`${estado}-seguro`}>
                            <td>{getEstadoName(estado)} - Seguro</td>
                            <td className="number-cell-DM">{formatCurrency(data.total_valor_seguro99)}</td>
                          </tr>
                          {parseFloat(data.total_valor_servicio) > 0 && (
                            <tr key={`${estado}-servicio`}>
                              <td>{getEstadoName(estado)} - Servicio</td>
                              <td className="number-cell-DM">{formatCurrency(data.total_valor_servicio)}</td>
                            </tr>
                          )}
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="cardAD">
                  <div className="icon-circle-AD track-changes-icon">
                    <span className="material-icons-sharp" style={{ fontSize: '28px', marginTop: 3 }}> timeline </span>
                  </div>
                  <h3>Procesos Iniciados</h3>
                  <table className="card-table-DM">
                    <tbody>
                      {Object.entries(seguroData.estado_general.procesos_iniciados.desglose_por_estado)
                        .filter(([key]) => key !== 'descripcion')
                        .map(([estado, data]) => (
                        <tr key={estado}>
                          <td>{getEstadoName(estado)}</td>
                          <td className="number-cell-DM">{formatNumber(data.cantidad)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
            <div className="rowAD">
              <div className="cardAD">
                <div className="icon-circle-AD local-shipping-icon">
                  <span className="material-icons-sharp" style={{ fontSize: '28px', marginTop: 3 }}> account_balance </span>
                </div>
                <h3>Análisis Financiero</h3>
                <table className="card-table-DM">
                  <tbody>
                    <tr>
                      <td>Valor Recaudado</td>
                      <td className="number-cell-DM">{formatCurrency(seguroData.estado_general.cobertura_financiera.valor_recaudado_seguro.valor)}</td>
                    </tr>
                    <tr>
                      <td>Valor a Cubrir</td>
                      <td className="number-cell-DM">{formatCurrency(seguroData.estado_general.cobertura_financiera.valor_a_cubrir.valor)}</td>
                    </tr>
                    <tr>
                      <td>Diferencia</td>
                      <td className="number-cell-DM">{formatCurrency(seguroData.estado_general.cobertura_financiera.diferencia.valor)}</td>
                    </tr>
                    <tr>
                      <td>Estado</td>
                      <td className="number-cell-DM">{seguroData.estado_general.cobertura_financiera.diferencia.estado}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="cardAD">
                <div className="icon-circle-AD check-circle-icon">
                  <span className="material-icons-sharp" style={{ fontSize: '28px', marginTop: 3 }}> insights </span>
                </div>
                <h3>Detalle Envíos Entregados</h3>
                <table className="card-table-DM">
                  <tbody>
                    <tr>
                      <td>Cantidad</td>
                      <td className="number-cell-DM">{formatNumber(seguroData.estado_general.envios_con_seguro.entregados.cantidad)}</td>
                    </tr>
                    <tr>
                      <td>Total Seguro</td>
                      <td className="number-cell-DM">{formatCurrency(seguroData.estado_general.envios_con_seguro.entregados.total_seguro)}</td>
                    </tr>
                    <tr>
                      <td>Total Servicio</td>
                      <td className="number-cell-DM">{formatCurrency(seguroData.estado_general.envios_con_seguro.entregados.total_servicio)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="cardAD">
                <div className="icon-circle-AD report-icon">
                  <span className="material-icons-sharp" style={{ fontSize: '28px', marginTop: 3 }}> backup </span>
                </div>
                <h3>Detalle Envíos Devueltos</h3>
                <table className="card-table-DM">
                  <tbody>
                    <tr>
                      <td>Cantidad</td>
                      <td className="number-cell-DM">{formatNumber(seguroData.estado_general.envios_con_seguro.devueltos.cantidad)}</td>
                    </tr>
                    <tr>
                      <td>Total Seguro</td>
                      <td className="number-cell-DM">{formatCurrency(seguroData.estado_general.envios_con_seguro.devueltos.total_seguro)}</td>
                    </tr>
                    <tr>
                      <td>Backup Servicio</td>
                      <td className="number-cell-DM">{formatCurrency(seguroData.estado_general.envios_con_seguro.devueltos.total_servicio_backup)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="rowAD">
              <div className="cardAD">
                <div className="icon-circle-AD track-changes-icon">
                  <span className="material-icons-sharp" style={{ fontSize: '28px', marginTop: 3 }}> pending_actions </span>
                </div>
                <h3>Envíos Pendientes</h3>
                <table className="card-table-DM">
                  <tbody>
                    <tr>
                      <td>Cantidad</td>
                      <td className="number-cell-DM">{formatNumber(seguroData.estado_general.envios_con_seguro.pendientes.cantidad)}</td>
                    </tr>
                    <tr>
                      <td>Total Seguro</td>
                      <td className="number-cell-DM">{formatCurrency(seguroData.estado_general.envios_con_seguro.pendientes.total_seguro)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="cardAD">
                <div className="icon-circle-AD public-icon">
                  <span className="material-icons-sharp" style={{ fontSize: '28px', marginTop: 3 }}> autorenew </span>
                </div>
                <h3>Envíos Intermedios</h3>
                <table className="card-table-DM">
                  <tbody>
                    <tr>
                      <td>Cantidad</td>
                      <td className="number-cell-DM">{formatNumber(seguroData.estado_general.envios_con_seguro.intermedios.cantidad)}</td>
                    </tr>
                    <tr>
                      <td>Total Seguro</td>
                      <td className="number-cell-DM">{formatCurrency(seguroData.estado_general.envios_con_seguro.intermedios.total_seguro)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="cardAD">
                <div className="icon-circle-AD local-shipping-icon">
                  <span className="material-icons-sharp" style={{ fontSize: '28px', marginTop: 3 }}> trending_up </span>
                </div>
                <h3>Métricas Adicionales</h3>
                <table className="card-table-DM">
                  <tbody>
                    <tr>
                      <td>Total Cobrado</td>
                      <td className="number-cell-DM">{formatCurrency(seguroData.estado_general.metricas.total_cobrado_seguro.valor)}</td>
                    </tr>
                    <tr>
                      <td>Cobertura %</td>
                      <td className="number-cell-DM">{Number(seguroData.estado_general.metricas.analisis_financiero.porcentaje_cobertura).toFixed(2)}%</td>
                    </tr>
                    <tr>
                      <td>Estado</td>
                      <td className="number-cell-DM">{seguroData.estado_general.metricas.analisis_financiero.estado}</td>
                    </tr>
                    <tr>
                      <td>Diferencia</td>
                      <td className="number-cell-DM">{formatCurrency(seguroData.estado_general.metricas.analisis_financiero.diferencia)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Modal para mostrar la tabla de sucursales */}
            {showModal && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <div className="modal-header">
                    <h2 style={{ margin: 0, color: '#1976D2' }}>
                      Resumen de Seguro por Sucursales
                    </h2>
                    <button onClick={handleCloseModal} className="modal-close-btn">
                      ×
                    </button>
                  </div>
                  
                  {/* Selector de período */}
                  <div className="periodo-selector">
                    <span className="periodo-label">
                      Seleccionar período:
                    </span>
                    <div className="periodo-buttons">
                      {[
                        { value: 'global', label: 'Global' },
                        { value: '15', label: 'Últimos 15 días' },
                        { value: '30', label: 'Últimos 30 días' }
                      ].map(periodo => (
                        <button
                          key={periodo.value}
                          onClick={() => handlePeriodoChange(periodo.value)}
                          className={`periodo-btn ${selectedPeriodo === periodo.value ? 'active' : ''}`}
                          disabled={loadingSucursales}
                        >
                          {periodo.label}
                        </button>
                      ))}
                    </div>
                  </div>
                  
                  {loadingSucursales ? (
                    <div className="loading-indicator">
                      <div className="loading-spinner"></div>
                      <p style={{ margin: 0, color: '#666', fontSize: '16px' }}>
                        Cargando datos de sucursales...
                      </p>
                    </div>
                  ) : sucursalesData ? (
                    <div>
                      {/* Resumen general */}
                      <div className="sucursales-summary">
                        <div>
                          <h4 style={{ margin: 0, color: '#1976D2' }}>Total Sucursales</h4>
                          <p style={{ margin: 0, fontSize: '20px', fontWeight: 'bold' }}>
                            {formatNumber(sucursalesData.total_sucursales)}
                          </p>
                        </div>
                        <div>
                          <h4 style={{ margin: 0, color: '#1976D2' }}>Período Seleccionado</h4>
                          <p style={{ margin: 0, fontSize: '16px', fontWeight: 'bold' }}>
                            {getPeriodoLabel(selectedPeriodo)}
                          </p>
                        </div>
                        <div>
                          <h4 style={{ margin: 0, color: '#1976D2' }}>Estado</h4>
                          <p style={{ margin: 0, fontSize: '14px', color: loadingSucursales ? '#FF9800' : '#4CAF50' }}>
                            {loadingSucursales ? 'Cargando...' : 'Datos actualizados'}
                          </p>
                        </div>
                      </div>

                      {/* Tabla de sucursales - Comentada la versión anterior */}
                      {/* 
                      <div style={{ marginBottom: '20px', textAlign: 'right' }}>
                        <button 
                          onClick={downloadSucursalesExcel}
                          disabled={!sucursalesData || loadingSucursales || isLoadingButtonExcel}
                          className="btn-download-excel-seguro99-admin"
                        >
                          <span style={{ fontSize: '16px' }}>📊</span>
                          Descargar Excel
                        </button>
                      </div>
                      <div style={{ overflowX: 'auto' }}>
                        <table className="sucursales-table">
                          <thead>
                            <tr>
                              <th 
                                className={`sortable-header ${isColumnActive('codigo_sucursal', sucursalesSortConfig) ? 'active' : ''}`}
                                style={{ minWidth: '100px' }}
                                onClick={() => handleSucursalesSort('codigo_sucursal')}
                                title="Ordenar por código de sucursal"
                              >
                                <div className="header-content">
                                  <span>Código</span>
                                  {getSortIcon('codigo_sucursal', sucursalesSortConfig)}
                                </div>
                              </th>
                              <th 
                                className={`sortable-header ${isColumnActive('nombre_sucursal', sucursalesSortConfig) ? 'active' : ''}`}
                                style={{ minWidth: '200px' }}
                                onClick={() => handleSucursalesSort('nombre_sucursal')}
                                title="Ordenar por nombre de sucursal"
                              >
                                <div className="header-content">
                                  <span>Nombre Sucursal</span>
                                  {getSortIcon('nombre_sucursal', sucursalesSortConfig)}
                                </div>
                              </th>
                              <th 
                                className={`sortable-header ${isColumnActive('total_envios_seguro', sucursalesSortConfig) ? 'active' : ''}`}
                                style={{ textAlign: 'center', minWidth: '100px' }}
                                onClick={() => handleSucursalesSort('total_envios_seguro')}
                                title="Ordenar por total de envíos"
                              >
                                <div className="header-content">
                                  <span>Total Envíos</span>
                                  {getSortIcon('total_envios_seguro', sucursalesSortConfig)}
                                </div>
                              </th>
                              <th 
                                className={`sortable-header ${isColumnActive('entregas', sucursalesSortConfig) ? 'active' : ''}`}
                                style={{ textAlign: 'center', minWidth: '100px' }}
                                onClick={() => handleSucursalesSort('entregas')}
                                title="Ordenar por número de entregas"
                              >
                                <div className="header-content">
                                  <span>Entregas</span>
                                  {getSortIcon('entregas', sucursalesSortConfig)}
                                </div>
                              </th>
                              <th 
                                className={`sortable-header ${isColumnActive('devoluciones', sucursalesSortConfig) ? 'active' : ''}`}
                                style={{ textAlign: 'center', minWidth: '100px' }}
                                onClick={() => handleSucursalesSort('devoluciones')}
                                title="Ordenar por número de devoluciones"
                              >
                                <div className="header-content">
                                  <span>Devoluciones</span>
                                  {getSortIcon('devoluciones', sucursalesSortConfig)}
                                </div>
                              </th>
                              <th 
                                className={`sortable-header ${isColumnActive('porcentaje_entregas', sucursalesSortConfig) ? 'active' : ''}`}
                                style={{ textAlign: 'center', minWidth: '100px' }}
                                onClick={() => handleSucursalesSort('porcentaje_entregas')}
                                title="Ordenar por porcentaje de entregas"
                              >
                                <div className="header-content">
                                  <span>% Entregas</span>
                                  {getSortIcon('porcentaje_entregas', sucursalesSortConfig)}
                                </div>
                              </th>
                              <th 
                                className={`sortable-header ${isColumnActive('porcentaje_devoluciones', sucursalesSortConfig) ? 'active' : ''}`}
                                style={{ textAlign: 'center', minWidth: '100px' }}
                                onClick={() => handleSucursalesSort('porcentaje_devoluciones')}
                                title="Ordenar por porcentaje de devoluciones"
                              >
                                <div className="header-content">
                                  <span>% Devoluciones</span>
                                  {getSortIcon('porcentaje_devoluciones', sucursalesSortConfig)}
                                </div>
                              </th>
                              <th 
                                className={`sortable-header ${isColumnActive('porcentaje_seguro_actual', sucursalesSortConfig) ? 'active' : ''}`}
                                style={{ textAlign: 'center', minWidth: '100px' }}
                                onClick={() => handleSucursalesSort('porcentaje_seguro_actual')}
                                title="Ordenar por porcentaje de seguro actual"
                              >
                                <div className="header-content">
                                  <span>% Seguro Actual</span>
                                  {getSortIcon('porcentaje_seguro_actual', sucursalesSortConfig)}
                                </div>
                              </th>
                              <th 
                                className={`sortable-header ${isColumnActive('muestra_minima', sucursalesSortConfig) ? 'active' : ''}`}
                                style={{ textAlign: 'center', minWidth: '120px' }}
                                onClick={() => handleSucursalesSort('muestra_minima')}
                                title="Ordenar por muestra mínima"
                              >
                                <div className="header-content">
                                  <span>Muestra Mínima</span>
                                  {getSortIcon('muestra_minima', sucursalesSortConfig)}
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {sortData(sucursalesData.sucursales, sucursalesSortConfig).map((sucursal, index) => (
                              <tr key={sucursal.codigo_sucursal}>
                                <td style={{ fontWeight: 'bold', color: '#1976D2' }}>
                                  {sucursal.codigo_sucursal}
                                </td>
                                <td>
                                  {sucursal.nombre_sucursal}
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: '600' }}>
                                  {formatNumber(sucursal.total_envios_seguro)}
                                </td>
                                <td style={{ textAlign: 'center', color: '#4CAF50', fontWeight: '600' }}>
                                  {formatNumber(sucursal.entregas)}
                                </td>
                                <td style={{ textAlign: 'center', color: '#f44336', fontWeight: '600' }}>
                                  {formatNumber(sucursal.devoluciones)}
                                </td>
                                <td style={{ 
                                  textAlign: 'center', 
                                  color: sucursal.porcentaje_entregas >= 80 ? '#4CAF50' : sucursal.porcentaje_entregas >= 60 ? '#FF9800' : '#f44336',
                                  fontWeight: '600'
                                }}>
                                  {sucursal.porcentaje_entregas.toFixed(2)}%
                                </td>
                                <td style={{ 
                                  textAlign: 'center', 
                                  color: sucursal.porcentaje_devoluciones <= 20 ? '#4CAF50' : sucursal.porcentaje_devoluciones <= 40 ? '#FF9800' : '#f44336',
                                  fontWeight: '600'
                                }}>
                                  {sucursal.porcentaje_devoluciones.toFixed(2)}%
                                </td>
                                <td style={{ 
                                  textAlign: 'center', 
                                  fontWeight: '600'
                                }}>
                                  {(sucursal.porcentaje_seguro_actual * 100).toFixed(2)}%
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                  <span className={`status-badge ${sucursal.muestra_minima ? 'status-success' : 'status-danger'}`}>
                                    {sucursal.muestra_minima ? 'Sí' : 'No'}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      */}

                      {/* Nueva tabla de sucursales con Ant Design */}
                      <div style={{ marginBottom: '20px', textAlign: 'right' }}>
                        <button 
                          onClick={downloadSucursalesExcel}
                          disabled={!sucursalesData || loadingSucursales || isLoadingButtonExcel}
                          className="btn-download-excel-seguro99-admin"
                        >
                          <span style={{ fontSize: '16px' }}>📊</span>
                          Descargar Excel
                        </button>
                      </div>
                      <Table
                        columns={sucursalesColumns}
                        dataSource={sucursalesData?.sucursales || []}
                        rowKey="codigo_sucursal"
                        pagination={false}
                        scroll={{ x: 1200 }}
                        loading={loadingSucursales}
                        size="middle"
                        bordered
                        style={{ 
                          backgroundColor: 'white',
                          borderRadius: '8px',
                          overflow: 'hidden'
                        }}
                      />
                    </div>
                  ) : (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                      <p>Error al cargar los datos de sucursales</p>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Modal para mostrar las alertas de seguro */}
            {showAlertasModal && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <div className="modal-header">
                    <h2 style={{ margin: 0, color: '#f44336' }}>
                      🚨 Alertas de Seguro
                    </h2>
                    <button onClick={handleCloseAlertasModal} className="modal-close-btn">
                      ×
                    </button>
                  </div>
                  
                  {loadingAlertas ? (
                    <div className="loading-indicator">
                      <div className="loading-spinner"></div>
                      <p style={{ margin: 0, color: '#666', fontSize: '16px' }}>
                        Cargando alertas de seguro...
                      </p>
                    </div>
                  ) : alertasData ? (
                    <div>
                      {/* Información general */}
                      <div className="sucursales-summary">
                        <div>
                          <h4 style={{ margin: 0, color: '#666' }}>Fecha de Análisis</h4>
                          <p style={{ margin: 0, fontSize: '14px' }}>
                            {new Date(alertasData.fecha_analisis).toLocaleString('es-ES')}
                          </p>
                        </div>
                        <div>
                          <h4 style={{ margin: 0, color: '#f44336' }}>Alertas Críticas</h4>
                          <p style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', color: '#f44336' }}>
                            {alertasData.alertas.roja ? alertasData.alertas.roja.length : 0}
                          </p>
                        </div>
                        <div>
                          <h4 style={{ margin: 0, color: '#ff9800' }}>Alertas Moderadas</h4>
                          <p style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', color: '#ff9800' }}>
                            {alertasData.alertas.amarilla ? alertasData.alertas.amarilla.length : 0}
                          </p>
                        </div>
                        <div>
                          <h4 style={{ margin: 0, color: '#4caf50' }}>Alertas Leves</h4>
                          <p style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', color: '#4caf50' }}>
                            {alertasData.alertas.verde ? alertasData.alertas.verde.length : 0}
                          </p>
                        </div>
                        <div>
                          <h4 style={{ margin: 0, color: '#1976D2' }}>Total de Alertas</h4>
                          <p style={{ margin: 0, fontSize: '20px', fontWeight: 'bold', color: '#1976D2' }}>
                            {allAlertas.length}
                          </p>
                        </div>
                      </div>

                      <div style={{ marginBottom: '20px', textAlign: 'right' }}>
                              <button 
                                onClick={downloadAlertasExcel}
                                disabled={!allAlertas || loadingAlertas || isLoadingButtonExcel}
                                className="btn-download-excel-seguro99-admin"
                              >
                                <span style={{ fontSize: '16px' }}>📊</span>
                                Descargar Excel
                              </button>
                            </div>
                      {/* Alertas críticas (rojas) - Comentada la versión anterior */}
                      {/*
                      {allAlertas && allAlertas.length > 0 && (
                        <div style={{ marginBottom: '20px' }}>
                          <h3 className="alert-critical-header">
                            <span className="material-icons-sharp">warning</span>
                            Todas las Alertas de Seguro - Revisión por Prioridad
                          </h3>
                          
                          <div 
                            style={{ 
                              overflowX: 'auto',
                              maxHeight: '70vh',
                              overflowY: 'auto'
                            }}
                          >
                            <table className="sucursales-table alert-critical-table">
                              <thead>
                                <tr>
                                  <th 
                                    className={`sortable-header ${isColumnActive('codigo_sucursal', alertasSortConfig) ? 'active' : ''}`}
                                    style={{ minWidth: '100px' }}
                                    onClick={() => handleAlertasSort('codigo_sucursal')}
                                    title="Ordenar por código de sucursal"
                                  >
                                    <div className="header-content">
                                      <span>Código</span>
                                      {getSortIcon('codigo_sucursal', alertasSortConfig)}
                                    </div>
                                  </th>
                                  <th 
                                    className={`sortable-header ${isColumnActive('nombre_sucursal', alertasSortConfig) ? 'active' : ''}`}
                                    style={{ minWidth: '200px' }}
                                    onClick={() => handleAlertasSort('nombre_sucursal')}
                                    title="Ordenar por nombre de sucursal"
                                  >
                                    <div className="header-content">
                                      <span>Nombre Sucursal</span>
                                      {getSortIcon('nombre_sucursal', alertasSortConfig)}
                                    </div>
                                  </th>
                                  <th 
                                    className={`sortable-header ${isColumnActive('tipo_alerta', alertasSortConfig) ? 'active' : ''}`}
                                    style={{ textAlign: 'center', minWidth: '120px' }}
                                    onClick={() => handleAlertasSort('tipo_alerta')}
                                    title="Ordenar por tipo de alerta"
                                  >
                                    <div className="header-content">
                                      <span>Tipo de Alerta</span>
                                      {getSortIcon('tipo_alerta', alertasSortConfig)}
                                    </div>
                                  </th>
                                  <th 
                                    className={`sortable-header ${isColumnActive('total_envios_seguro', alertasSortConfig) ? 'active' : ''}`}
                                    style={{ textAlign: 'center', minWidth: '100px' }}
                                    onClick={() => handleAlertasSort('total_envios_seguro')}
                                    title="Ordenar por total de envíos"
                                  >
                                    <div className="header-content">
                                      <span>Total Envíos</span>
                                      {getSortIcon('total_envios_seguro', alertasSortConfig)}
                                    </div>
                                  </th>
                                  <th 
                                    className={`sortable-header ${isColumnActive('entregas', alertasSortConfig) ? 'active' : ''}`}
                                    style={{ textAlign: 'center', minWidth: '100px' }}
                                    onClick={() => handleAlertasSort('entregas')}
                                    title="Ordenar por número de entregas"
                                  >
                                    <div className="header-content">
                                      <span>Entregas</span>
                                      {getSortIcon('entregas', alertasSortConfig)}
                                    </div>
                                  </th>
                                  <th 
                                    className={`sortable-header ${isColumnActive('devoluciones', alertasSortConfig) ? 'active' : ''}`}
                                    style={{ textAlign: 'center', minWidth: '100px' }}
                                    onClick={() => handleAlertasSort('devoluciones')}
                                    title="Ordenar por número de devoluciones"
                                  >
                                    <div className="header-content">
                                      <span>Devoluciones</span>
                                      {getSortIcon('devoluciones', alertasSortConfig)}
                                    </div>
                                  </th>
                                  <th 
                                    className={`sortable-header ${isColumnActive('porcentaje_entregas', alertasSortConfig) ? 'active' : ''}`}
                                    style={{ textAlign: 'center', minWidth: '100px' }}
                                    onClick={() => handleAlertasSort('porcentaje_entregas')}
                                    title="Ordenar por porcentaje de entregas"
                                  >
                                    <div className="header-content">
                                      <span>% Entregas</span>
                                      {getSortIcon('porcentaje_entregas', alertasSortConfig)}
                                    </div>
                                  </th>
                                  <th 
                                    className={`sortable-header ${isColumnActive('porcentaje_devoluciones', alertasSortConfig) ? 'active' : ''}`}
                                    style={{ textAlign: 'center', minWidth: '100px' }}
                                    onClick={() => handleAlertasSort('porcentaje_devoluciones')}
                                    title="Ordenar por porcentaje de devoluciones"
                                  >
                                    <div className="header-content">
                                      <span>% Devoluciones</span>
                                      {getSortIcon('porcentaje_devoluciones', alertasSortConfig)}
                                    </div>
                                  </th>
                                  <th 
                                    className={`sortable-header ${isColumnActive('nivel_alerta', alertasSortConfig) ? 'active' : ''}`}
                                    style={{ textAlign: 'center', minWidth: '120px' }}
                                    onClick={() => handleAlertasSort('nivel_alerta')}
                                    title="Ordenar por nivel de alerta"
                                  >
                                    <div className="header-content">
                                      <span>Nivel de Alerta</span>
                                      {getSortIcon('nivel_alerta', alertasSortConfig)}
                                    </div>
                                  </th>
                                  <th 
                                    className={`sortable-header ${isColumnActive('descripcion', alertasSortConfig) ? 'active' : ''}`}
                                    style={{ textAlign: 'center', minWidth: '200px' }}
                                    onClick={() => handleAlertasSort('descripcion')}
                                    title="Ordenar por descripción"
                                  >
                                    <div className="header-content">
                                      <span>Descripción</span>
                                      {getSortIcon('descripcion', alertasSortConfig)}
                                    </div>
                                  </th>
                                  <th 
                                    className={`sortable-header ${isColumnActive('recomendacion', alertasSortConfig) ? 'active' : ''}`}
                                    style={{ textAlign: 'center', minWidth: '200px' }}
                                    onClick={() => handleAlertasSort('recomendacion')}
                                    title="Ordenar por recomendación"
                                  >
                                    <div className="header-content">
                                      <span>Recomendación</span>
                                      {getSortIcon('recomendacion', alertasSortConfig)}
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {sortData(allAlertas, alertasSortConfig).map((alerta, index) => (
                                  <tr key={`${alerta.codigo_sucursal}-${index}`}>
                                    <td style={{ fontWeight: 'bold', color: alerta.color_nivel }}>
                                      {alerta.codigo_sucursal}
                                    </td>
                                    <td style={{ fontWeight: '600' }}>
                                      {alerta.nombre_sucursal}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                      <span 
                                        style={{ 
                                          padding: '4px 8px',
                                          borderRadius: '12px',
                                          fontSize: '12px',
                                          fontWeight: '600',
                                          backgroundColor: alerta.color_nivel,
                                          color: 'white',
                                          textTransform: 'capitalize'
                                        }}
                                      >
                                        {alerta.tipo_alerta}
                                      </span>
                                    </td>
                                    <td style={{ textAlign: 'center', fontWeight: '600' }}>
                                      {formatNumber(alerta.total_envios_seguro)}
                                    </td>
                                    <td style={{ textAlign: 'center', color: '#4CAF50', fontWeight: '600' }}>
                                      {formatNumber(alerta.entregas)}
                                    </td>
                                    <td style={{ textAlign: 'center', color: alerta.color_nivel, fontWeight: '600' }}>
                                      {formatNumber(alerta.devoluciones)}
                                    </td>
                                    <td style={{ 
                                      textAlign: 'center', 
                                      color: alerta.porcentaje_entregas === 0 ? '#f44336' : '#4CAF50',
                                      fontWeight: '600'
                                    }}>
                                      {alerta.porcentaje_entregas.toFixed(2)}%
                                    </td>
                                    <td style={{ 
                                      textAlign: 'center', 
                                      color: alerta.color_nivel,
                                      fontWeight: '600'
                                    }}>
                                      {alerta.porcentaje_devoluciones.toFixed(2)}%
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                      <span 
                                        style={{ 
                                          padding: '6px 12px',
                                          borderRadius: '20px',
                                          fontSize: '12px',
                                          fontWeight: '700',
                                          backgroundColor: alerta.color_nivel,
                                          color: 'white',
                                          textTransform: 'uppercase',
                                          letterSpacing: '0.5px'
                                        }}
                                      >
                                        {alerta.nivel_alerta}
                                      </span>
                                    </td>
                                    <td className="descripcion-cell">
                                      {alerta.descripcion}
                                    </td>
                                    <td className="recomendacion-cell">
                                      {alerta.recomendacion}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                      */}

                      {/* Nueva tabla de alertas con Ant Design */}
                      {allAlertas && allAlertas.length > 0 && (
                        <div style={{ marginBottom: '20px' }}>
                          <h3 className="alert-critical-header">
                            <span className="material-icons-sharp">warning</span>
                            Todas las Alertas de Seguro - Revisión por Prioridad
                          </h3>
                          
                          <Table
                            columns={alertasColumns}
                            dataSource={allAlertas}
                            rowKey={(record, index) => `${record.codigo_sucursal}-${index}`}
                            pagination={false}
                            scroll={{ x: 1500 }}
                            loading={loadingAlertas}
                            size="middle"
                            bordered
                            style={{ 
                              backgroundColor: 'white',
                              borderRadius: '8px',
                              overflow: 'hidden'
                            }}
                          />
                        </div>
                      )}

                      {/* Mensaje si no hay alertas */}
                      {allAlertas && allAlertas.length === 0 && (
                        <div className="no-alerts-container">
                          <span className="material-icons-sharp no-alerts-icon">
                            check_circle
                          </span>
                          <h3 className="no-alerts-title">
                            ¡Excelente! No hay alertas críticas
                          </h3>
                          <p className="no-alerts-text">
                            Todas las sucursales están operando dentro de los parámetros normales.
                          </p>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                      <p style={{ color: '#f44336', fontSize: '16px' }}>
                        Error al cargar las alertas de seguro
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        ) : (
          <p>Cargando datos...</p>
        )}
      </div>
    </>
  );
};

export default Seguro99;